/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vehicleNumber: NonNullable<unknown> }} Vehicle_Details_NumberInputs */

const fr_vehicle_details_number = /** @type {(inputs: Vehicle_Details_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Véhicule n°${i?.vehicleNumber}`)
};

const en_vehicle_details_number = /** @type {(inputs: Vehicle_Details_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vehicle no. ${i?.vehicleNumber}`)
};

/**
* | output |
* | --- |
* | "Vehicle no. {vehicleNumber}" |
*
* @param {Vehicle_Details_NumberInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_number = /** @type {((inputs: Vehicle_Details_NumberInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_NumberInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_number(inputs)
	return en_vehicle_details_number(inputs)
});